import { render, staticRenderFns } from "./commodityServe.vue?vue&type=template&id=acf3bb56&scoped=true"
import script from "./commodityServe.vue?vue&type=script&lang=js"
export * from "./commodityServe.vue?vue&type=script&lang=js"
import style0 from "./commodityServe.vue?vue&type=style&index=0&id=acf3bb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf3bb56",
  null
  
)

export default component.exports